export default __webpack_public_path__ + "static/media/icone-compartilhar.5cbe62a2.svg";